<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Administration')}}</a>
                </router-link>
                <router-link to="/tariffs" tag="li" class="breadcrumb-item"><a href="">{{i18n("Cashier's Logs")}}</a></router-link>
            </ol>
        </nav>


        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n("Cashier's Logs")}}</h1>
            </div>
        </div>

        <div class="base_box_cnt gray_box">
            <div class="row">
                <div class="col-xl-2 col-sm-2">
                    <div class="input-group day date">
                        <datepicker
                                v-model="log_time"
                                :inputClass="'form-control base_input'"
                                :bootstrap-styling="true"
                                :calendar-button="true"
                                calendar-button-icon="mdi mdi-calendar"
                                format="dd.MM.yyyy" class="m_datepicker">
                        </datepicker>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-4">

                    <div class="form-inline">
                        <label class="col-form-label fs-12">{{i18n('Cashier')}}:</label>
                        <model-list-select :list="cashiers"
                                           :class="'ml-3'"
                                           v-model="cashier"
                                           option-value="id"
                                           option-text="name" class="w-50"
                                           placeholder="Выберите кассира">
                        </model-list-select>
                        <a href="#" class="btn">
                            <i class="mdi mdi-close" v-if="cashier !== null" @click.prevent="cashier = null"></i>
                        </a>
                    </div>
                </div>
                <div class="col-xl-4 col-sm-4">
                        <div class="form-inline">
                            <label class="col-form-label fs-12 mr-3" for="to">{{i18n('Cashier action')}}:</label>
                            <input type="text" class="form-control" id="to" @keyup.enter="filterStations()" v-model="to">
                        </div>
                </div>
            </div>
        </div>


        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th>{{i18n('Cashier')}}</th>
                                <th>{{i18n("Cashier Actions")}}</th>
                                <th>{{i18n("date")}}</th>
                                <th>{{i18n("Description")}}</th>
                                <th class="text-center">{{i18n("Action")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, key) in logs">
                                <td>{{key + 1}}</td>
                                <td>{{item.cashier.name}}</td>
                                <td>{{item.action}}</td>
                                <td>{{item.created_at}}</td>
                                <td>{{item.description}}</td>
                                <td class="text-center">
                                    <button type="button" class="btn-icon" @click="showDetail(item.id)">
                                        <i class="mdi mdi-eye text-primary"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <pagination :links="links" :url="'cashier-logs'"></pagination>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel"
             id="showDetailModal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title h4" id="myExtraLargeModalLabel">{{i18n("Action Details")}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>

                    </div>
                    <div class="modal-body">
                        <div v-show="one_log_files">
                            <div class="col-md-10">
                                <ul>
                                    <li v-for="(item, key) in one_log_files"
                                        style="cursor: pointer">{{item}}
                                    </li>
                                </ul>
                            </div>
<!--                            <div class="result col-md-9" style="float: left;">-->
<!--                                <div class="header_log">-->

<!--                                </div>-->
<!--                                <div class="view" v-show="one_file_details">-->
<!--                                    <table class="table table-borderless">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th scope="col">Действия</th>-->
<!--                                            <th scope="col">Описание</th>-->
<!--                                            <th scope="col">Запрос</th>-->
<!--                                            <th scope="col">Ответ</th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->
<!--                                        <tbody>-->
<!--                                        <tr>-->
<!--                                            <th scope="row">{{one_file_details.action}}</th>-->
<!--                                            <td>{{one_file_details.description}}</td>-->
<!--                                            <td>-->
<!--                                                <ul>-->
<!--                                                    <li v-for="(items, key) in one_file_details.request">-->
<!--                                                        <h3>Request № {{key}}</h3>-->
<!--                                                        <h6 style="margin: 0px;" v-for="(item, key) in items">{{item}}</h6>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                            </td>-->
<!--                                            <td>-->
<!--                                                <ul>-->
<!--                                                    <li v-for="(items, key) in one_file_details.response">-->
<!--                                                        <h3>Response № {{key}}</h3>-->
<!--                                                            <h6 v-for="(item, key) in items" style="margin: 0px;"><strong>{{key}}</strong>: {{item}}</h6>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                            </td>-->
<!--                                        </tr>-->
<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                        <div v-show="!one_log_files">
                            {{i18n("No date")}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Pagination from "../../components/Pagination";
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import {ModelListSelect} from 'vue-search-select';

    export default {
        name: "CashierLogs",
        components: {
            Pagination,
            ModelListSelect,
            Datepicker,
        },
        data() {
            return {
                logs: [],
                cashiers: [],
                status: 0,
                links: {},
                page: 1,
                cashier: null,
                log_time: this.$moment().format("MM.DD.YYYY"),
                one_log_files: null,
                one_file_details: {
                    action: null,
                    description: null,
                    response: null,
                    request: null,
                },
                to: ''
            }
        },
        created() {
            this.getCashiers();
            this.getLogs();
        },
        beforeRouteUpdate(to, from, next) {
            let page = to.params.page;
            if (page) {
                this.page = page;
                this.getLogs();
            }
            next();
        },
        methods: {
            getLogs() {
                this.$api.post('cashier.logs', {page: this.page, cashier: this.cashier, time: this.log_time, to: this.to})
                    .then(res => {
                        this.logs = res.data;
                        this.links = res.links;
                    }).finally(() => {

                });
            },
            getCashiers() {
                this.$api.get('users.index', {user_type: 3, status: 10})
                    .then(res => {
                        this.cashiers = res.data.users;
                    });
            },
            showDetail(log_id) {
                this.getDetailedLog(log_id);
                $('#showDetailModal').modal('show');
            },
            getDetailedLog(log_id) {
                this.$api.get('cashier.detail', {action: log_id})
                    .then(res => {
                        this.one_log_files = res.data;
                    });
            },
            async readFile(file) {
                this.one_file_details.action = null;
                this.one_file_details.description = null;
                this.one_file_details.response = null;
                this.one_file_details.request = null;
                this.$api.get('cashier.read-file', {file: file})
                    .then(res => {
                        this.one_file_details = res.data;
                    });
            },
			filterStations() {
            	this.page = 1;
            	this.getLogs();
            }
        },
        watch: {
            cashier: function () {
                this.getLogs();
            },
            log_time: function (n, o) {
                n !== o && this.getLogs();
            },
        },
    }
</script>

<style scoped>
    .left_sidebar {
        width: 17%;
        float: left;
        border-right: 1px solid;
        height: 100%;
    }

    .result {
        margin-left: 10px;
        width: 83%;

    }

</style>
